import React from 'react'
import PropTypes from 'prop-types'
import UserIcon from "../../../../../gd-components/icons/user/user"
import HintPopover from "../../../../../gd-ui/hint-popover/hint-popover"

// extends React.Component is required because of reference in parent
export default class FieldUser_MultiselectPopoverOption extends React.Component<any> {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {
        if (this.props.option.disabled) {
            return
        }
        this.props.onClick(this.props.option)
        return
    }

    render() {
        const disabled = this.props.option.disabled
        const classes  = Classes('option pill', {
            'highlighted'   : this.props.isHighlighted,
            'no-hover'      : disabled,
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {disabled &&
                    <HintPopover
                        type        = "small"
                        multiline   = {true}
                        hint        = {this.props.option.hint}
                    />
                }
                {!this.props.option.isAllValuesOption &&
                    <div className={Classes("ui5-cb fl-no-shrink s-16 m-r-10", this.props.className, {
                        selected    : this.props.isSelected,
                        disabled    : !!disabled,
                    })}/>
                }
                {this.props.option.icon &&
                    <div className="w-22 h-22 fl-center fl-no-shrink m-r-8">
                        <div className={Classes("icon ui5-ico-16", this.props.option.icon)}/>
                    </div>
                }
                {!this.props.option.icon && this.props.option.value &&
                    <UserIcon
                        className   = "fl-no-shrink m-r-8"
                        userId      = {this.props.option.value}
                        size        = "22"
                    />
                }
                <div className="ui5-txt-default">{this.props.option.label}</div>
            </div>
        )
    }
}
